export const Types = {
  CLEAR_SELECTED_ANSWERS: 'uiQuestions/CLEAR_SELECTED_ANSWERS',
  INITIALIZE: 'uiQuestions/INITIALIZE',
  SELECT_ANSWER: 'uiQuestions/SELECT_ANSWER',
};

export const initialState = {
  selectedAnswers: {},
};

export const Actions = {
  clearSelectedAnswers: () => ({
    type: Types.CLEAR_SELECTED_ANSWERS,
  }),
  initialize: () => ({
    type: Types.INITIALIZE,
  }),
  selectAnswer: payload => ({
    payload,
    type: Types.SELECT_ANSWER,
  }),
};



// WEBPACK FOOTER //
// ./src/redux/ui/questions/actions.js